import './App.css';
import TopBar from './components/TopBar';
import Header from './components/Header';
import Skills from './components/Skills';
import About from './components/About';

function App() {
  return (
    <div>
      <TopBar />
      <Header />
      <Skills />
      <About />
    </div>
  );
}

export default App;
